/**Local Env*/
// REACT_APP_CONNECT_INSTANCE_NAME=transformholding--acdev00
// REACT_APP_API_GATEWAY_URL=1z3xskpe15.execute-api.us-east-1.amazonaws.com/v0
// REACT_APP_API_GATEWAY_API_KEY=IyrZrqjgzA7Ym5AoNerJy10ownANq19622yIvstW
// REACT_APP_CONNECT_LOGIN_ENDPOINT=transformholding--acdev00.awsapps.com

// Old URLS
// const connectEndpoint = `https://transformholding--acdev00.awsapps.com/connect/`;
// const apiGatewayEndpoint = `https://1z3xskpe15.execute-api.us-east-1.amazonaws.com/v0`;
// const loginEndPoint = 'https://transformholding--acdev00.awsapps.com/connect/login';

// New URLS
// const connectEndpoint = `https://transformholding--acdev00.my.connect.aws`;
// const apiGatewayEndpoint = `https://1z3xskpe15.execute-api.us-east-1.amazonaws.com/v0`;
// const loginEndPoint = 'https://transformholding--acdev00.my.connect.aws/login';

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// From .env File
const connectEndpoint = `https://${process.env.REACT_APP_CONNECT_INSTANCE_NAME}.awsapps.com`;
const apiGatewayEndpoint = `https://${process.env.REACT_APP_API_GATEWAY_URL}`;
const loginEndPoint = `https://${process.env.REACT_APP_CONNECT_LOGIN_ENDPOINT}`;

const papiGatewayEndpoint = `https://${process.env.REACT_APP_API_GATEWAY_URL}/ccinfo`;
const rapiGatewayEndpoint = `https://${process.env.REACT_APP_API_GATEWAY_URL}/recording`;
const capiGatewayEndpoint = `https://${process.env.REACT_APP_API_GATEWAY_URL}/updateStripePaymentIDInConnectFlow`;
const ragEndpoint = `https://7uxffs9xv7.execute-api.us-east-1.amazonaws.com/dev/custom-rag`;
const chatDataEndpoint = process.env.REACT_APP_CHAT_DATA_ENDPOINT;

// Configuration for OLD URL
const Connect = {
  ccp: `${connectEndpoint}/connect/ccp-v2#`,
  login : loginEndPoint,
  logout: `${connectEndpoint}/connect/logout`,
};

// Configuration for new URL
// const Connect = {
//   ccp: `${connectEndpoint}/ccp-v2#`,
//   login : loginEndPoint,
//   logout: `${connectEndpoint}/logout`,
// };

// Other endpoints for APIs, etc.
const EndPointInfo = {
  Connect,
  papiGatewayEndpoint,
  apiGatewayEndpoint,
  rapiGatewayEndpoint,
  capiGatewayEndpoint,
  ragEndpoint,
  chatDataEndpoint,
};

export default EndPointInfo;
